import React from 'react';
import { FaFacebookF, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { Link } from 'react-router-dom';



const Footer: React.FC = () => {
    return (
        <div className='bg-[#f8f9ff]'>
            <footer className=" text-[#666666] pt-16 px-4 md:px-12  max-w-6xl mx-auto">
                {/* Top Row */}
                <div className="flex flex-col md:flex-row justify-between items-center mb-6">
                    {/* Logo */}
                    <div className="text-blue-500 text-2xl font-semibold mb-4 md:mb-0">
                        <Link to="/">
                            <img src="/logo.png" alt="" className='h-10' />
                        </Link>
                    </div>

                    {/* Social Icons */}
                    <div className="flex space-x-6 text-xl text-[#0f0a33]">
                        <Link to="https://www.facebook.com/mintermindssoftwaredevelopmentservices"><FaFacebookF className="hover:text-blue-600 cursor-pointer transition" /></Link>
                       <Link to="https://www.instagram.com/minterminds_sds/" > <FaInstagram className="hover:text-pink-600 cursor-pointer transition" /></Link>
                       <Link to="https://www.linkedin.com/company/minterminds-software-development-services/"><FaLinkedin className="hover:text-blue-400 cursor-pointer transition" /></Link> 
                    </div>
                </div>

                <hr className="border-2 border-[#201f2214] mb-4" />

                {/* Bottom Row */}
                <div className="flex flex-col md:flex-row py-8 justify-between items-center text-lg font-semibold text-gray-500">
                    <p className="mb-2 md:mb-0">© Copyright 2025 Minterminds. All Rights Reserved.</p>

                    <div className="flex space-x-6 t">
                        <Link to="/policy" className="hover:text-gray-700 !text-md">Privacy Policy</Link>
                        <Link to="/terms" className="hover:text-gray-700 !text-md">Terms & Conditions</Link>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Footer;
